import React from 'react';

export interface ChangeIndicatorProps {
  children: React.ReactNode;
  isChanged?: boolean;
  className?: string;
}

/**
 * ChangeIndicator - Visual wrapper that highlights edited fields
 * Shows a colored border or background for fields that have been modified
 * Session-based indicator (cleared on page refresh)
 */
export const ChangeIndicator: React.FC<ChangeIndicatorProps> = ({
  children,
  isChanged = false,
  className = '',
}) => {
  return (
    <div
      className={`
        relative
        ${isChanged ? 'change-indicator-active' : ''}
        ${className}
      `}
    >
      {children}
      {isChanged && (
        <div className="absolute -left-1 top-0 bottom-0 w-1 bg-blue-500 rounded-l-sm" />
      )}
    </div>
  );
};

// Add this to your global CSS (index.css):
// .change-indicator-active input,
// .change-indicator-active select,
// .change-indicator-active textarea {
//   @apply border-blue-400 bg-blue-50;
// }
